import React, { ReactElement } from 'react'
import { StyledAdmin } from '../styled-components'

import CategoryCards from '../../../components/Admin/category/preview-category'
import { TrainingGroup as TrainingGroupType } from '../../../types/training'

interface AdminTrainigProps {
  trainingsGroup: TrainingGroupType
}

const AdminTraining = ({ trainingsGroup }: AdminTrainigProps): ReactElement => (
  <StyledAdmin>
    <CategoryCards trainingsGroup={trainingsGroup} />
  </StyledAdmin>
)

export default AdminTraining
